import lang from '../../../lang/index.js'

import { StringSchema } from '../../index.js'

export default function numeric(this: StringSchema) {
  /* eslint-disable */
  return this.matches(
    /^\d+$/,
    lang().validation.integer()
  )
  /* eslint-enable */
}
